module.exports = __webpack_public_path__ + "static/mierb-book-6da309e746547d1eecdb0506d320e65a.woff";